<template>
  <!-- Навігаційне меню -->

  <div class="navbar-nav menuScroll scroll-ultrathin" ref="menuRoot">

    <!-- Пошук по меню -->
    <searchBox v-if="this.fullMenu === true" @searchB="searchB" class="searchMenu"/>

      <template v-for="(option, i) in options">

        <template v-if="option.type && option.type == 'menuTitle'">
            <li class="menu-title" v-if="option.sectionTitle && isShowMenuTitle(option)">
                <span data-key="t-menu">{{ option.sectionTitle }}</span>
            </li>
        </template>

        <template v-else>

            <!-- Перевірка на відображення меню та наявність БІЛЬШЕ НІЖ ОДНОЇ видимої підопції -->
            <template v-if="isShowItem(option) && option.children && visibleChildren(option).length > 1">

                <li class="nav-item menu-item-has-children" :key="i">
                    <a
                        class="nav-link menu-link collapsed"
                        :href="option.children ? '#'+option.name : undefined"
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarDashboards"
                        @click="onParentClick($event, option)"
                    >
                        <i :class="option.icon"></i> <span>{{option.meta.title()}}</span>
                    </a>
                    
                    <!-- Випадаюче підменю -->
                    <div class="menu-dropdown collapse" :id="option.children ? option.name : undefined">
                        <!-- Перебір підменю -->
                        <template v-for="(suboption, j) in option.children" :key="j">
                            <ul class="nav nav-sm flex-column" v-if="isShowItem(suboption)" style="overflow: hidden">
                                <li class="nav-item"  >
                                    <!-- Відкриття у новій вкладці -->
                                    <a
                                        v-if="suboption.external"
                                        class="nav-link menu-link"
                                        :href="suboption.href"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        {{ suboption.meta.title ? suboption.meta.title() : '' }}
                                    </a>

                                    <router-link v-else :to="'/'+suboption.to" class="nav-link menu-link" @click="openMenu(suboption.to, null, null)">
                                        {{suboption.meta.title ? suboption.meta.title() : ''}}
                                    </router-link>
                                </li>
                                
                            </ul>
                        </template>
                    </div>
                </li>
            </template>

            <!-- Перевірка на відображення опції без підопцій АБО лише з однією видимою підопцією -->
            <template v-if="isShowItem(option) && !(option.children && visibleChildren(option).length > 1)">
                <li class="menu-title" v-if="option.sectionTitle">
                    <span data-key="t-menu">{{ option.sectionTitle }}</span>
                </li>
                <li class="nav-item" :key="i">
                    <router-link class="nav-link menu-link" :to="'/' + menuLinkTo(option)" @click="openMenu(menuLinkTo(option), j, null)">
                    <i :class="option.icon"></i>
                    <span>{{option.meta.title()}}</span>
                    
                    <!-- Мітка нового розділу -->
                    <span class="badge badge-pill bg-danger" v-if="option.dateNew && (option.dateNew > currentDate())">New</span>
                    <span class="badge badge-pill bg-danger" v-if="option.beta">Beta</span>
                    </router-link>
                </li>
                </template>
            </template>
        </template>
    </div>

  <!--
    Flyout-підменю для звуженого меню (тільки іконки).
    Рендериться в body з position: fixed — інакше його обрізає .menuScroll,
    який через overflow є scroll-контейнером шириною в 70px.
  -->
  <Teleport to="body">
    <div
      v-if="flyout.option"
      ref="flyout"
      class="menu-flyout scroll-ultrathin"
      :style="{ top: flyout.top + 'px', left: flyout.left + 'px' }"
    >
      <div class="menu-flyout-title">{{ flyout.option.meta.title() }}</div>
      <ul class="menu-flyout-list">
        <li v-for="(suboption, k) in visibleChildren(flyout.option)" :key="k">
          <!-- Відкриття у новій вкладці -->
          <a
            v-if="suboption.external"
            class="nav-link menu-link"
            :href="suboption.href"
            target="_blank"
            rel="noopener"
            @click="closeFlyout()"
          >
            {{ suboption.meta.title ? suboption.meta.title() : '' }}
          </a>

          <router-link
            v-else
            :to="'/' + suboption.to"
            class="nav-link menu-link"
            @click="onFlyoutLinkClick(suboption)"
          >
            {{ suboption.meta.title ? suboption.meta.title() : '' }}
          </router-link>
        </li>
      </ul>
    </div>
  </Teleport>
</template>

<script>
import router from "@/router"; // Імпорт роутера
import { storeS } from "@/store.js"; //Глобальное хранилище данных
import searchBox from '../../globaltable/searchbox.vue'; // компонент боксу пошуку

export default {
  data(){
    return {
      // Об'єкт для відстеження активного меню
      menu: {
        menu: null,
        submenu: null,
        subsubmenu: null,
      },
      activeMenu: '', // Активне меню
      searchMenu: '', // поле пошуку
      // Стан flyout-підменю для звуженого меню
      flyout: {
        option: null, // пункт меню, чиї підпункти показуємо
        name: null,   // ідентифікатор пункту (для повторного кліку = закрити)
        top: 0,
        left: 0
      }
    }
  },
  components: { searchBox },
  methods: {
    openMenu(i, j, k){
      // Метод відкриття меню

      let cleanedPath = this.activeMenu.substring(1);
      if(i == cleanedPath) { 
        this.$emit("reloadRoute");
      }
    },
    isCondensed() {
      // Чи меню зараз у звуженому стані (тільки іконки).
      // Дивимось на реальний атрибут, бо саме на нього спирається css.
      return document.documentElement.getAttribute("data-sidebar-size") === "sm";
    },
    onParentClick(e, option) {
      // Клік по пункту з підпунктами.
      // У повному меню працює звичайний bootstrap-collapse, у звуженому —
      // collapse скритий css-ом, тож замість нього відкриваємо flyout збоку.
      if (!this.isCondensed()) return;

      e.preventDefault();
      e.stopPropagation(); // щоб bootstrap не смикав collapse

      if (this.flyout.name === option.name) {
        this.closeFlyout();
        return;
      }

      this.openFlyout(option, e.currentTarget);
    },
    triggerRect(trigger) {
      // Вертикаль — від пункту меню, горизонталь — від країв сайдбара
      const itemEl = trigger.closest(".nav-item") || trigger;
      const menuEl = trigger.closest(".navbar-menu");
      const itemRect = itemEl.getBoundingClientRect();
      const menuRect = menuEl ? menuEl.getBoundingClientRect() : itemRect;

      return {
        top: itemRect.top,
        left: menuRect.left,
        right: menuRect.right
      };
    },
    openFlyout(option, trigger) {
      // Відкриття flyout навпроти іконки, по якій клікнули.
      // По вертикалі орієнтуємось на <li>, а не на <a>: на ховері css розтягує
      // сам <a> до 270px. По горизонталі — на край сайдбара, бо <li> закінчується
      // там, де починається смуга скролу, і панель налазила б на неї.
      const rect = this.triggerRect(trigger);

      this.flyout = {
        option: option,
        name: option.name,
        top: rect.top,
        left: rect.right + 4
      };

      this.$nextTick(() => this.positionFlyout(rect));

      document.addEventListener("mousedown", this.onDocumentMousedown);
      document.addEventListener("keydown", this.onFlyoutKeydown);
      window.addEventListener("resize", this.closeFlyout);
      if (this.$refs.menuRoot) {
        this.$refs.menuRoot.addEventListener("scroll", this.closeFlyout);
      }
    },
    positionFlyout(rect) {
      // Утримуємо панель у межах екрану: якщо не влазить знизу — піднімаємо,
      // якщо не влазить справа — показуємо злива від іконки.
      const el = this.$refs.flyout;
      if (!el) return;

      const margin = 8;
      let top = rect.top;
      let left = rect.right + 4;

      if (top + el.offsetHeight > window.innerHeight - margin) {
        top = Math.max(margin, window.innerHeight - margin - el.offsetHeight);
      }
      if (left + el.offsetWidth > window.innerWidth - margin) {
        left = Math.max(margin, rect.left - el.offsetWidth - 4);
      }

      this.flyout.top = top;
      this.flyout.left = left;
    },
    closeFlyout() {
      // Закриття flyout та зняття слухачів
      if (!this.flyout.option) return;

      this.flyout = { option: null, name: null, top: 0, left: 0 };

      document.removeEventListener("mousedown", this.onDocumentMousedown);
      document.removeEventListener("keydown", this.onFlyoutKeydown);
      window.removeEventListener("resize", this.closeFlyout);
      if (this.$refs.menuRoot) {
        this.$refs.menuRoot.removeEventListener("scroll", this.closeFlyout);
      }
    },
    onDocumentMousedown(e) {
      // Клік поза панеллю закриває її.
      // Кліки по самих пунктах меню пропускаємо — їх обробляє onParentClick
      // (інакше повторний клік по тій самій іконці закривав і одразу відкривав панель).
      if (this.$refs.flyout && this.$refs.flyout.contains(e.target)) return;
      if (e.target.closest && e.target.closest(".app-menu .nav-link.menu-link")) return;

      this.closeFlyout();
    },
    onFlyoutKeydown(e) {
      if (e.key === "Escape") this.closeFlyout();
    },
    onFlyoutLinkClick(suboption) {
      // Перехід у розділ з flyout: перезавантажуємо розділ, якщо він вже відкритий
      this.openMenu(suboption.to, null, null);
      this.closeFlyout();
    },
    currentDate(){
      // Отримання поточної дати

      var date = new Date();
      var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + (date.getDate() + 1)).slice(-2)
      return dateStr
    },
    isShowMenuTitle(option){

         // Якщо немає масиву прав — не показуємо
        if (!option || !Array.isArray(option.perms)) return false;
        
        // Якщо хоча б один з прав є у користувача
        return option.perms.some(perm => this.perms[perm] === true);
    },
    isShowItem(option) {
      // Метод перевірки відображення пункту меню та пошук по меню
      
      const title = option.meta.title ? option.meta.title().toLowerCase() : '';
      const search = this.searchMenu.toLowerCase();

      // Перевірка на 1-му рівні
      const isOnFirstLevel = (
        title !== '' &&
        title.includes(search) &&
        (this.perms[666] === true ||
          this.perms[option.meta.perms] === true ||
          this.perms[option.meta.perms] === null ||
          this.user.workerJob === option.meta.role
        )
      );

      // Перевірка на 2-му рівні
      const hasMatchingChild = option.children && Object.values(option.children).some(child => {
        const childTitle = child.meta.title ? child.meta.title().toLowerCase() : '';
        return childTitle !== '' && childTitle.includes(search);
      });

      if(isOnFirstLevel == true && hasMatchingChild == true) {
        return isOnFirstLevel || hasMatchingChild
      } else {
        return isOnFirstLevel
      }
      // return option.meta.title && option.meta.title() != '' && option.meta.title() != null && (this.perms[2000] == true || this.perms[option.meta.perms] == true || this.perms[option.meta.perms] == null);
    },
    visibleChildren(option) {
      // Повертає лише ті дочірні пункти, які реально видимі поточному користувачу.
      // Якщо видимий лише один — сенсу в дропдауні немає, пункт малюється звичайним посиланням.
      if (!option.children) return [];
      return Object.values(option.children).filter(child => this.isShowItem(child));
    },
    menuLinkTo(option) {
      // Ціль посилання для пункту без дропдауна:
      // якщо є рівно одна видима підопція — ведемо одразу на неї, інакше на сам пункт.
      if (option.children) {
        const visible = this.visibleChildren(option);
        if (visible.length === 1 && visible[0].to) return visible[0].to;
      }
      return option.to;
    },
    onRoutechange(ele) {
      // Метод для відстеження зміни маршруту

      this.initActiveMenu(ele);
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
      }
    },
    initActiveMenu(ele) {
      // Метод ініціалізації активного меню

      this.activeMenu = ele
      setTimeout(() => {
        if (document.querySelector("#navbar-nav")) {
          let a = document.querySelector("#navbar-nav").querySelector('[href="'+ ele +'');
          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                  parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                const grandparent = parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.parentElement.closest(".collapse");
                if(grandparent && grandparent && grandparent.previousElementSibling){
                  grandparent.previousElementSibling.classList.add("active");
                  grandparent.classList.add("show");
                }
              }
            }
          }
        }
      }, 0);
    },
    toggleMenu() {
      // Метод для зміни стану меню
      
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    searchB(e){
      // пошук
      this.searchMenu = e
    }
  },
  watch: {
    $route(to, from) {
      //Ця штука дивиться в якій директорії ми знаходимося та відкриває відповідний пункт меню
      var url = to.path;
      this.onRoutechange(url);
      this.closeFlyout();
    },
    fullMenu(val) {
      // Меню розгорнули — flyout більше не потрібен
      if (val === true) this.closeFlyout();
    }
  },
  beforeUnmount() {
    this.closeFlyout();
  },
  mounted(){
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");

      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                siblingCollapse.classList.remove("show");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2)
                item.firstElementChild.setAttribute("aria-expanded", "false");
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                item1.classList.remove("show");
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.style.display = "none";
          });
        });
      });
    }
  },
  computed: {
    options() {
      // Отримання опцій меню з глобального сховища

      // Отримання ієрархії меню в потрібному форматі
      let options = {}
      const curMenu = storeS.newMenu

      // Функція для рекурсивного отримання структури меню
      let getOptionsNode = (localNode) => {
        if (localNode.children) {
          let children = {};
          for (let key in localNode.children) {
            let child = localNode.children[key];
            children[child.name] = getOptionsNode(child);
            if(localNode.name == "Загальна інформація") {
            }
          }
          localNode.children = children;
        }
        return localNode;
      }
      
      for(let key in curMenu) {
        let currentNode = curMenu[key];
        let name = currentNode.name;
        options[name] = getOptionsNode(currentNode);
      }

      console.log('options', options);
      
      return options;
    },
    perms(){
      return storeS.perms
    },
    fullMenu() {
      return storeS.fullMenu;
    },
    user() {
      return storeS.userbase;
    }
  }
}
</script>

<style scoped>
.nav-link.menu-link {
  border-radius: 9px;
}

/* Звужене меню: іконка по центру колонки. Шаблонні padding-x (1.5rem) та
   min-width іконки (1.75rem) розраховані на меню з текстом і зсували іконку вправо */
html[data-sidebar-size="sm"] .menuScroll .nav-link.menu-link {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
}

html[data-sidebar-size="sm"] .menuScroll .nav-link.menu-link i {
  min-width: auto;
  margin-right: 0;
}

/* Ховер більше не розтягує пункт на 270px — підменю тепер відкривається
   по кліку окремою панеллю, а розтягнутий пункт лише зсував іконку */
/* .nav-link у селекторі — щоб гарантовано перебити шаблонне правило
   (у нього така сама специфічність, і воно подекуди вигравало: на ховері
   показувався текст пункту й виштовхував іконку за межі 70px) */
html[data-sidebar-size="sm"] .menuScroll .nav-item:hover > a.nav-link.menu-link {
  width: auto;
}

html[data-sidebar-size="sm"] .menuScroll .nav-item:hover > a.nav-link.menu-link span,
html[data-sidebar-size="sm"] .menuScroll .nav-item:hover > .menu-dropdown {
  display: none;
}

/* Шеврон дропдауна (:after з MDI-гліфом) шаблон показує на ховері й ставить
   right: 18px — на нерозтягнутому пункті він лягав прямо на іконку.
   Роль підказки тут виконує крапка нижче */
html[data-sidebar-size="sm"] .menuScroll .nav-item:hover > a.nav-link.menu-link::after {
  display: none;
}

/* У звуженому меню текст пунктів схований, тож позначаємо крапкою ті,
   що є дропдаунами — щоб було видно, де клік відкриє підменю */
html[data-sidebar-size="sm"] .menuScroll .nav-item.menu-item-has-children::after {
  content: "";
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  opacity: .55;
  pointer-events: none; /* щоб крапка не перехоплювала клік по іконці */
}

a.router-link-active, a.router-link-active>a {
  background: #2196f3;
  color: white!important;
  /* margin: 0px 5px; */
  /* border-top-left-radius: 15px;
  border-bottom-left-radius: 15px; */
}

.menuScroll {
  /* Займаємо всю вільну висоту сайдбара (він flex-колонка) — без фіксованої
     height, інакше знизу лишається порожнє місце, а список скролиться раніше */
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
/* Вигляд скролбара меню — глобальний (assets/scss/structure/_scrollbars.scss) */

/* Flyout-підменю звуженого меню */
.menu-flyout {
  position: fixed;
  z-index: 1005; /* вище за сайдбар та топбар, нижче за модалки (1050) */
  min-width: 210px;
  max-width: 280px;
  max-height: calc(100vh - 16px);
  overflow-y: auto;
  padding: 6px;
  border-radius: 8px;
  background: var(--vz-vertical-menu-bg-dark, #212529);
  border: 1px solid rgba(255, 255, 255, .08);
  box-shadow: 0 6px 18px rgba(0, 0, 0, .35);
}

.menu-flyout-title {
  padding: 6px 12px 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .05em;
  text-transform: uppercase;
  /* фіксовані кольори, а не змінні теми: у звуженому меню пункти вже без іконок,
     тож тьмяний текст читався погано */
  color: #9fa8b5;
}

.menu-flyout-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.menu-flyout .nav-link.menu-link {
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  white-space: normal;
  font-size: 14px;
  color: #eef0f2;
}

.menu-flyout .nav-link.menu-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, .1);
}


</style>

<style>
.menuScroll input.form-control.search {
  background: none;
  color: white;
  border: none;
}
/* .menuScroll input.form-control.search:hover {
  border-bottom: 1px solid #bdc1c43d;
}
.menuScroll input.form-control.search:focus {
  border-bottom: 1px solid #bdc1c43d;
} */
.search-box.searchMenu {
  margin: 9px 5%;
  margin-bottom: 17px;
  background: #495057;
  border-radius: 5px;
  box-shadow: 0 1px 2px rgb(56 65 74);
  margin: 17px 7%;
  width: 90%!important;
}
</style>